import React, { useEffect, useState, useCallback } from "react";

interface CountdownTimerProps {
  eventDateTime: Date;
  label?: string;
  icon?: string;
  className?: string;
}

const CountdownTimerComponent: React.FC<CountdownTimerProps> = ({
  eventDateTime,
  label = "to event",
  icon = "⏱️",
  className = "",
}) => {
  const [remaining, setRemaining] = useState("00:00:00");

  const updateTimer = useCallback(() => {
    if (!eventDateTime) {
      setRemaining("");
      return;
    }
    const diff = eventDateTime.getTime() - Date.now();
    if (diff <= 0) {
      setRemaining("00:00:00");
    } else {
      const hrs = String(Math.floor(diff / 3600000)).padStart(2, "0");
      const mins = String(Math.floor((diff % 3600000) / 60000)).padStart(
        2,
        "0",
      );
      const secs = String(Math.floor((diff % 60000) / 1000)).padStart(2, "0");
      setRemaining(`${hrs}:${mins}:${secs}`);
    }
  }, [eventDateTime]);

  useEffect(() => {
    updateTimer(); // Initial update
    const intervalId = setInterval(updateTimer, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, [updateTimer]);

  if (!eventDateTime || !remaining) {
    return null;
  }

  return (
    <div
      className={`inline-flex w-full justify-center items-center px-10 py-3 bg-black rounded-full ${className}`}
    >
      <span className="mr-2">{icon}</span>
      <span className="text-white/50 font-medium">
        {remaining} {label}
      </span>
    </div>
  );
};

CountdownTimerComponent.defaultProps = {
  label: "to event",
  icon: "⏱️",
  className: "",
};

const CountdownTimer = CountdownTimerComponent;

export default CountdownTimer;
